import {ExamsDataItem} from "./ExamsDataItem";

export class ExamsData {
  // mandatory: ExamsDataItem[] = [];
  // profile: ExamsDataItem[] = [];
  // mandatoryEnt: ExamsDataItem[] = [];
  // profileEnt: ExamsDataItem[] = [];
  admissionSubjects: ExamsDataItem[] = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/dialogs/common-dialog/model/ExamsData.ts